export const EAccountPlansType = {
  None: 0,

  Basic: 1,

  Standard: 2,

  Pro: 3,

  Premium: 4,

  Enterprise: 5,

  Scale: 6,
}

export type EAccountPlansType = (typeof EAccountPlansType)[keyof typeof EAccountPlansType]
